export { default } from './About.js';
